import styled from "styled-components";
import { FlexProps } from "./Flex.types";

export const Flex = styled.div<FlexProps>`
  display: flex;
  align-items: ${({ alignItems }) => alignItems ?? "center"};
  justify-content: ${({ justifyContent }) => justifyContent ?? "space-between"};
  gap: ${({ gap }) => gap};
  flex-direction: ${({ flexDirection }) => flexDirection ?? "row"};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  margin: ${({ margin }) => `${margin}`};
  padding: ${({ padding }) => `${padding}`};
  width: ${({ width }) => `${width}`};
  max-width: ${({ maxWidth }) => `${maxWidth}`};
  min-width: ${({ minWidth }) => `${minWidth}`};
  height: ${({ height }) => `${height}`};
  max-height: ${({ maxHeight }) => `${maxHeight}`};
  min-height: ${({ minHeight }) => `${minHeight}`};
  border: ${({ border }) => `${border}`};
`;

export const FlexGrow = styled.div`
  flex-grow: 1;
`;
